import React, { useMemo, useState } from 'react'
import { useDropzone } from 'react-dropzone'

// components
import {
  CCol,
  CFormLabel,
  CFormInput,
  CImage,
  CButton,
  CFormText
} from '@coreui/react-pro'

// icons
import UploadImageIcon from '../../../assets/icons/UploadImageIcon.png'

// styling
import { styleButtonVars4 } from '../../custom-styles/buttonStyles'
import {
  baseStyle,
  focusedStyle,
  acceptStyle,
  textUploadDropZoneStyle1,
  textUploadDropZoneStyle2
} from '../../custom-styles/containerStyle'

const FormFileUpload = ({
  formProductImages,
  colSize,
  inputLabel,
  className,
  name,
  value,
  handleFileOnDrop,
  handleFileInput,
  feedbackInvalid,
  invalid,
  multiple,
  errors,
  optional,
  maxFiles = 12,
  maxSize = 50000000,
  supportedFileTypes = '.jpg .jpeg, .png, .pdf .docx .doc .xlsx .xls'
}) => {
  const [fileErrors, setFileErrors] = useState("");

  const {
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept
  } = useDropzone({
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'application/pdf': [],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
      'application/msword': [],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
      'application/vnd.ms-excel': []
    },
    maxFiles: maxFiles,
    maxSize: maxSize,
    multiple: true,
    onDrop: (acceptedFiles, fileRejections) => {
      fileRejections.forEach((file) => {
        file.errors.forEach((err) => {
          if (err.code === "file-too-large") {
            setFileErrors(`File too large`);
          }

          if (err.code === "file-invalid-type") {
            setFileErrors(`Invalid file type`);
          }

          if (err.code === 'too-many-files') {
            setFileErrors(`Only have upload ${maxFiles} files`);
          }
        });
      });
      handleFileOnDrop(acceptedFiles, name)
    }
  });

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isFocused ? focusedStyle : {}),
    ...(isDragAccept ? acceptStyle : {})
  }), [
    isFocused,
    isDragAccept
  ]);

  return (
    <CCol lg={colSize} className={className}>
      <div className='d-grid gap-2 d-md-flex align-items-center'>
        <CFormLabel>
          {inputLabel}
        </CFormLabel>
        <p
          style={{
            color: '#9E9E9E',
            fontSize: '16px',
            marginBottom: '.5rem'
          }}
        >
          {
            formProductImages ? 'You can upload up to 12 images'
              : optional ? 'Optional' : ""
          }
        </p>
      </div>
      <div {...getRootProps({ style })}>
        <CImage fluid src={UploadImageIcon} className="mt-4" />
        <p className="my-3" style={textUploadDropZoneStyle2}>Drag &amp; Drop Files Here</p>
        <p className="my-2" style={textUploadDropZoneStyle1}><i>or</i></p>
        <CFormInput
          id="upload_product_images"
          className="position-absolute invisible"
          name={name}
          type="file"
          value={value}
          onChange={(e) => handleFileInput(e, name)}
          feedbackInvalid={feedbackInvalid}
          invalid={invalid}
          multiple={multiple}
          accept={supportedFileTypes}
          {...getInputProps()}
        />
        <label className="my-3" htmlFor="upload_product_images">
          <CButton style={styleButtonVars4}>Choose File(s)</CButton>
        </label>
        {formProductImages && errors.product_images && (
          <CFormText className='error-text-field'>
            {errors.product_images}
          </CFormText>
        )}
        {fileErrors && (
          <CFormText className='error-text-field'>
            {fileErrors}
          </CFormText>
        )}
        <p className="my-2" style={textUploadDropZoneStyle1}>Maximum file size {maxSize / 1000000}MB per file</p>
        <p style={textUploadDropZoneStyle1}>Supported file type: {supportedFileTypes}</p>
      </div>
    </CCol >
  )
}

export default FormFileUpload
